import { QueryTypes } from 'services/api/data'

import { getPureGameId } from 'modules/SlotsRoot/providersData/GameCatalog/uniqGameId'
import { ISlotProviderConfigurationItem, Providers } from 'modules/SlotsRoot/types/configuration'
import { ISlotViewItem } from 'modules/SlotsRoot/types/interfaces/Slots/Slots'

import { SOFTGAMING_PROVIDERS } from './constants'
import SoftgamingConverter from './SoftgamingConverter'

const converter = new SoftgamingConverter()

export const SOFTGAMING_CONFIG: ISlotProviderConfigurationItem<SoftgamingConverter> = {
  gameListUrl: `api/integrations/${Providers.SoftGaming}/games?producer=${SOFTGAMING_PROVIDERS.join(',')}&page_size=10000`,
  converter,
  slotsCount: 101,
  sessionUrlData: {
    url: `api/integrations/${Providers.SoftGaming}/login`,
    method: QueryTypes.POST,
    // isNeedDoubleRequest: true,
    getBody: params => ({
      is_mobile: +!params.isDesktop,
      system: params.gameList.find((t: ISlotViewItem) => t.gameId === params.gameId)?.additionalData?.system,
      page_code: getPureGameId(params.gameId),
      auth_type: 'html',
    }),
    converter: converter.convertGameUrl,
  },
}
